<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="1"></ucMenu>
					<div class="right_con">
						<div class="goods_main" v-loading="isLoading">
							<p class="fb">复制任务</p>
							<div class="select_wrap">
								<el-input class="w290 mr" v-model="searchData.title" placeholder="请输入任务名称" clearable>
									<p slot="prefix" class="label_title">任务名称</p>
								</el-input>
								<el-button plain size="small" @click="getList">查询</el-button>
								<el-button plain size="small" @click="resetSearch">重置</el-button>
							</div>
							<div class="tabs_wrap">
								<p class="tab" :class="state==0?'active':''" @click="bindSate(0)">全部</p>
								<p class="tab" :class="state==100?'active':''" @click="bindSate(100)">待处理</p>
								<p class="tab" :class="state==110?'active':''" @click="bindSate(110)">处理中</p>
								<p class="tab" :class="state==200?'active':''" @click="bindSate(200)">处理完成</p>
							</div>
							<div class="totals_btn">
								<p class="totals">共{{page_data.total}}条</p>
								<el-button plain size="small" @click="openAdd()">一键复制</el-button>
								<el-button plain size="small" @click="postBatDel()">批量删除</el-button>
								<el-button plain size="small" @click="getList()">刷新</el-button>
							</div>
							<div class="list_title">
								<el-table
										:header-row-style="{background:'#f9f9f9', color:'#666', 'line-hight':'50px', 'height': '50px','text-align':'center'}"
								    :data="list"
										@selection-change="selection" row-key="id"
										v-loading="isLoading" 
								    style="width: 100%">
										<el-table-column align="left" type="selection" width="50"></el-table-column>
										<el-table-column
										  prop="title"
										  label="任务名称"
										  width="210">
										</el-table-column>
										<el-table-column
										  prop="scope"
										  label="任务状态">
											<template slot-scope="scope">
												<p class="status sales" v-if="scope.row.status == 200">{{scope.row.status_text}}</p>
												<p class="status fail" v-if="scope.row.status == 110">{{scope.row.status_text}}</p>
												<p class="status xiajia" v-if="scope.row.status == 100">{{scope.row.status_text}}</p>
											</template>
										</el-table-column>
								    <el-table-column
								      prop="scope"
								      label="复制结果"
								      width="200">
											<template slot-scope="scope">
													<el-link type="" class="mr10" @click="openQueue(scope.row,0)">总数{{scope.row.total_num}}</el-link>
													<el-link type="success" class="mr10" @click="openQueue(scope.row,200)">成功{{scope.row.success_num}}</el-link>
													<el-link type="danger" class="mr10" @click="openQueue(scope.row,-10)">失败{{scope.row.failed_num}}</el-link>
											</template>
								    </el-table-column>
										<el-table-column
										  prop="createtime"
										  label="任务时间"
										  width="180">
										</el-table-column>
								    
										<el-table-column
										  prop="scope"
										  label="操作">
											<template slot-scope="scope">
												<p class="opts" @click="bindDel(scope.row.id)">删除</p>
											</template>
										</el-table-column>
								  </el-table>
							</div>
						</div>
						<Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getList" />
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="复制商品" :visible.sync="dialog.addDialog" width="50%" center >
		  <div class="opts_wrap">
				<div class="opts_line">
					<p class="txt">任务标题</p>
					<div class="con">
						<el-input type="text" :rows="5" placeholder="请输入任务名称" class="w100 ml8" v-model="form.title"></el-input>
					</div>
				</div>
		  	<div class="opts_line">
		  		<p class="txt">宝贝链接</p>
		  		<div class="con">
		  			<el-input type="textarea" :rows="5" placeholder="请输入商品链接,多个商品请换行,一次最多一千个商品" class="w180 ml8" v-model="form.product_urls"></el-input>
		  		</div>
		  	</div>
		  	<div class="btn_wrap">
		  		<p class="btn" @click="doAdd()">一键复制</p>
		  		<p class="btn" @click="dialog.addDialog = false">取消</p>
		  	</div>
		  </div>
		</el-dialog>
		<el-dialog :title="queueParam.name" :visible.sync="dialog.queueDialog" width="80%" center >
			<productQueue :status.sync="queueParam.status" :pid.sync="queueParam.pid" :show.sync="dialog.queueDialog"></productQueue>
		</el-dialog>
		
		<myFoot></myFoot>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
import { Loading } from 'element-ui';
import common from '@/assets/js/utils/common.js'
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import Pagination from '../../components/pagination/pagination';
import ucMenu from '../../components/ucenterMenu/ucmenu';
import productQueue from '../../components/productQueue/productQueue';
export default {
	name: "ucenterIndex",
	components:{
		myHead,myFoot,ucMenu,Pagination,productQueue
	},
	data() {
		return {
			isLoading: false,
			searchData:{},
			state:0,
			ids:'',
			list:[],
			page_data: {
				limit: 10,
				page: 1,
				total:0,
			},
			dialog: {
				addDialog:false,
				queueDialog:false
			},
			itv_auto_refresh:0,
			form:{
				title:'',
				product_urls:''
			},
			queueParam: {
				status: 0,
				pid: 0,
				name: ''
			}
		}
	},
	created() {
		this.getList()
		// this.autoRefresh()
	},
	destroyed() {
		// if(this.itv_auto_refresh){
		// 	clearInterval(this.itv_auto_refresh)
		// }
	},
	methods: {
		...mapActions({
			getProductTaskList:"ucenter/getProductTaskList",
			opProductTaskAdd:"ucenter/opProductTaskAdd",
			opProductTaskDel:"ucenter/opProductTaskDel",
		}),
		
		selection(selection) {
			this.ids = selection.map(item => item.id)
		},
		
		//重置搜索
		resetSearch(){
			this.searchData = {}
			this.getList()
		},
		//刷新列表
		refresh(){
			this.page_data.page = 1
			this.list = []
			this.getList()
		},
		//自动刷新
		// autoRefresh(){
		// 	let that = this
		// 	that.itv_auto_refresh = setInterval(function(){
		// 		that.getList(false)
		// 		// console.log('autoRefresh',that.itv_auto_refresh)
		// 	},5000)
			
		// },
		//获取任务列表
		getList(showLoading = true){
			if(showLoading) this.isLoading = true
			let param = {limit:this.page_data.limit,page:this.page_data.page,status:this.state}
			Object.assign(param, this.searchData)
			// console.log(param)
			this.getProductTaskList({data:param,success:(res)=>{
				if(res.code===200){
					console.log('get list',res.data.data)
					this.list = res.data.data
					this.page_data.total = res.data.total
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
				this.isLoading = false
			}})
		},
		//切换任务状态
		bindSate(e){
			this.state = e
			this.getList()
		},
		bindDel(id){
			this.ids = [id]
			this.postBatDel()
		},
		openAdd(){
			let time = new Date().getTime()*0.001
			let title = '复制任务'+ common._date(time,"YmdHis")
			this.form = {title:title,product_urls:''}
			this.dialog.addDialog = true
		},
		//提交复制任务
		doAdd(){
			let that = this
			let form = this.form
			if(form.title == ''){
				that.$message({message: '请输入标题',type: 'error'})
				return;
			}
			if(form.product_urls == ''){
				that.$message({message: '请输入宝贝链接',type: 'error'})
				return;
			}
			that.isLoading = true
			that.opProductTaskAdd({data:form,success:(res)=>{
				that.isLoading = false
				if(res.code == 200){
					that.$message({
						type: 'success',
						message: res.msg
					})
					that.refresh()
					that.dialog.addDialog = false
				}else{
					that.$message({
						type: 'error',
						message: res.msg
					})
				}
			}})
			
		},
		//删除
		postBatDel(){
			let that = this
			let ids = that.ids
			console.log(ids)
			if(ids.length == 0){
				that.$message({message: '请勾选任务',type: 'error'})
				return;
			}
			that.$confirm('确认删除选中任务吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				that.isLoading = true
				let param = {id:ids.join(',')}
				that.opProductTaskDel({data:param,success:(res)=>{
					// console.log(res)
					that.isLoading = false
					if(res.code == 200){
						that.$message({
							type: 'success',
							message: res.msg
						})
						that.refresh()
					}else{
						that.$message({
							type: 'error',
							message: res.msg
						})
					}
				}})
			}).catch((res) => {
				console.log(res)
			});
		},
		//弹窗复制任务记录
		openQueue(row,status){
			let queueParam = this.queueParam
			queueParam.name = row.title + '-' + (status == 0?'全部':status==200?'成功':'失败')
			queueParam.status = status
			queueParam.pid = row.id
			this.dialog.queueDialog = true
		},
	}
}
</script>

<style scoped>
.wrap .wrap_body{display: flex;flex-direction: column;}
.center{display: flex;flex: 1;}
.ucenter_main{padding: 28px 0 40px;display: flex;justify-content: space-between;flex: 1;min-height: 500px;}
.right_con{width: 980px;background: #fff;}
.goods_main{padding: 36px 40px 46px;}
.select_wrap{margin-top: 24px;display: flex;flex-wrap: wrap;}
.select_wrap .mr{margin-right: 10px;}
.select_wrap .w290{width: 290px;margin-top: 14px;position: relative;}
.select_wrap .cate-label{position: absolute;left: 5px;z-index: 1;}
.el-cascader{line-height: 34px;}
.select_wrap .label_title{width: 76px;height: 100%;font-size: 12px;color: #999;display: flex;align-items: center;padding-left: 6px;}
.tabs_wrap{width: 100%;height: 60px;border-bottom: 1px solid #eee;display: flex;}
.tabs_wrap .tab{height: 100%;padding: 30px 16px 0;position: relative;line-height: 1;cursor: pointer;font-size: 14px;color: #666;box-sizing: border-box;}
.tabs_wrap .tab.active{font-weight: bold;color: var(--red);}
.tabs_wrap .tab.active::after{content: '';width: 100%;height: 3px;background: var(--red);position: absolute;left: 0;bottom: 0;z-index: 2;}
.totals_btn{margin-top: 14px;display: flex;align-items: center;}
.totals_btn .totals{font-size: 12px;color: #333;padding-right: 16px;margin-right: 16px;line-height: 1;border-right: 1px solid #ccc;}

.list_title{margin-top: 10px;}
.list_title .status{width: 80px;display: flex;justify-content: flex-start;align-items: center;}
.list_title .status::before{content: '';width: 8px;height: 8px;border-radius: 50%;margin-right: 6px;}
.list_title .status.sales::before{background: #0ea11f;}
.list_title .status.xiajia::before{background: #ccc;}
.list_title .status.fail::before{background: var(--red);}
.list_title .status.fail{color: var(--red);}
.list_title .time{width: 60px;line-height: 16px;margin: 0 20px;}
.list_title .guanlian{color: #1966ff;cursor: pointer;}
.list_title .guanlian:hover{text-decoration: underline;}
.list_title .opts{color: var(--red);cursor: pointer;margin-top: 6px;display:inline-block;}
.list_title .opts:hover{text-decoration: underline;}

.header-row{background-color: #f9f9f9;}
.el-table .warning-row {background: oldlace;}
.el-table .success-row {background: #f0f9eb;}


.opts_wrap{padding-top: 14px;}
.opts_wrap .opts_line{margin-top: 30px;display: flex;align-items: center;}
.opts_line .txt{width: 110px;text-align: right;font-size: 14px;}
.opts_line .con{flex: 1;width: 0;margin-left: 22px;display: flex;align-items: center;}
.opts_line .con .t{font-size: 14px;color: var(--red);text-decoration: underline;cursor: pointer;}
.opts_wrap .btn_wrap{margin: 40px auto 0 auto;display: flex;align-items: center;justify-content: center;}
.opts_wrap .btn_wrap .btn{width: 80px;height: 34px;border-radius: 4px;display: flex;justify-content: center;align-items: center;cursor: pointer;box-sizing: border-box;font-size: 14px;}
.opts_wrap .btn_wrap .btn:nth-child(1){background: var(--red);color: #fff;margin-right: 14px;}
.opts_wrap .btn_wrap .btn:nth-child(2){background: #fff;color: #333;border: 1px solid #ddd;margin-right: 14px;}
.ml8{margin-left: 8px;}
.w100{width: 100%;}
</style>
<style>

.select_wrap .el-button{margin-top: 14px;margin-right:10px;margin-left: 0 !important;}
.el-input--prefix .el-input__inner,.el-cascader .el-input .el-input__inner{padding-left: 76px;height: 34px;line-height: 34px;}
.el-select .el-input.is-focus .el-input__inner ,.el-select .el-input__inner:focus{border-color: var(--red);}
.el-select-dropdown__item.selected,.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{color: var(--red);}
.el-input--prefix .el-input__inner:focus{border-color: var(--red);}
.el-input__prefix, .el-input__suffix{display: flex;align-items: center;}
.el-button{color: #333;border-color: #ddd;}
.el-button--small{padding: 7px 15px;}
.el-checkbox{color: #666;display: flex;align-items: center;}
.el-checkbox__inner{border-color: #ddd;width: 16px;height: 16px;}
.el-checkbox__input{display: flex;}
.el-checkbox__label{font-size: 12px;line-height: 1;}
.el-checkbox__inner::after{height: 9px;left: 5px;}
.el-checkbox__input.is-indeterminate .el-checkbox__inner::before{height: 4px;}
.mr10{margin-right: 10px;}
/*red border color*/
.el-button.is-plain:focus, .el-button.is-plain:hover ,.el-checkbox__inner:hover ,.el-checkbox__input.is-focus .el-checkbox__inner,.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus,.el-cascader .el-input .el-input__inner:focus,.el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner{border-color: var(--red);}

/*red color*/ 
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__input.is-checked+.el-checkbox__label, .el-pager li.active ,.el-pagination button:hover ,.el-pager li:hover{color: var(--red);}

/*red background color*/
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{background-color: var(--red);}

.el-button:focus, .el-button:hover{border-color: var(--red);color: var(--red);background:#fff;}
.el-button--primary{background: var(--red) !important;color: #fff !important;border-color: #fff;}
.el-button--primary:focus, .el-button:hover{border-color: var(--red);}
.el-loading-spinner .el-loading-text{color:var(--red);}
.el-loading-spinner .path{stroke: var(--red);}

.el-table th.el-table__cell{background-color: unset;}
.el-table th.el-table__cell>.cell{padding-left: 14px;padding-right: 14px;}
</style>
